import pluralize from 'pluralize';
import React from 'react';
import { useApi, useWorkspace } from '~/contexts';
import BulkActionModal from '~/components/bulk-action/BulkActionModal';
import TaskDetails from './TaskDetails';

export default function BulkLock({ projectId, ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  return (
    <BulkActionModal
      title="Bulk Lock"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .projects(projectId)
          .tasks()
          .bulkSetLockTime(ids, { lockTime: true })
          .then((r) => r.data)
      }
      renderRow={TaskDetails}>
      {`Are you sure you want to lock time tracking on ${ids.length} ${pluralize('task', ids.length)}? Members will no longer be able to add new time entries to ${pluralize('this', ids.length)} ${pluralize('task', ids.length)}.`}
    </BulkActionModal>
  );
}
